import baseStore from "./baseStore";
import riskIndicators from "./riskIndicators";
import contributingFactors from "./contributingFactors";
import acute from "./acute";
import longTerm from "./longTerm";
import communityCare from "./communityCare";
import ems from "./ems";

let initialStore = baseStore;
initialStore.sections.riskindicators = riskIndicators;
initialStore.sections.contributingfactors = contributingFactors;
initialStore.sections.riskratings.acute = acute;
initialStore.sections.riskratings.longterm = longTerm;
initialStore.sections.riskratings.communitycare = communityCare;
initialStore.sections.riskratings.ems = ems;

export default initialStore;



// WEBPACK FOOTER //
// ./src/initialStore/index.js